/* global swal moment */
import './style.less';
import { months } from '@prolaera/library';
import { cloneDeep, get, groupBy, keyBy, values } from 'lodash';
import licenseRequirementModalTemplate from 'modals/licenseRequirement/template.html';
import licenseRequirementModalCtrl from 'modals/licenseRequirement';

export default function($log, $q, $stateParams, $uibModal, ApiClass, RegulatorClass, ResolveClass, ProfileClass) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;

  const profile_uid = $stateParams.employeeID || $stateParams.id;
  const { profile } = ProfileClass.profileComplete;

  // Disables features
  vm.disable = profile && profile.company_id === 10 && !profile.admin;

  vm.profile_uid = profile_uid;

  vm.upload = false;
  vm.regIdSelected = false;
  vm.resultsQueried = false;
  vm.newLicense = {};
  vm.summary = false;
  vm.cpeDateBol = true;
  vm.formData = {};
  vm.birthday = false;
  vm.months = months;
  vm.licenses = [];
  vm.industries = [];
  vm.licenseColorDict = {
    wa_cpa: 'yellow-bg',
    or_cpa: 'lazur-bg',
    ca_cpa: 'red-bg'
  };
  vm.issueDate = { opened: false };
  vm.expirationDate = { opened: false };
  vm.cpeDate = { opened: false };
  vm.addLicenseToggle = false;

  vm.emailAddress = get(ProfileClass, 'profile_complete.company.preferences.licenses.emailAddress', false);

  vm.checkRoute = function(route) {
    return ResolveClass.isAllowedCompanyRoute(route);
  };

  vm.changeSummary = () => (vm.summary = false);

  vm.calcCpeDate = function(formData) {
    vm.summary = true;
    vm.formData.cpeDate = getCPEDate(
      vm.regulatorsDict[vm.formData.reg_id].cycle_renewal,
      vm.formData.reg_id,
      formData.expiration,
      formData.month
    );
  };

  vm.addLicense = () => {
    vm.licenseAdd = true;
    const reg_id = vm.formData.version || vm.formData.reg_id;

    const params = {
      update: false,
      profile_uid,
      cycle_date: moment(vm.formData.cpeDate).toISOString(),
      expiration_date: moment(vm.formData.expiration).toISOString(),
      issue_date: moment(vm.formData.issue).toISOString(),
      license_number: vm.formData.number,
      reciprocal: !!vm.formData.reciprocal,
      reg_id
    };

    vm.newLic.$setPristine();

    ApiClass.usersIdTypePut({ id: profile_uid, type: 'licenses', manage: false }, params, {})
      .then(() => {
        vm.resetForm();
        activate();
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.showLicenseRequirement = reg_id => {
    $uibModal
      .open({
        size: 'md',
        backdrop: true,
        template: licenseRequirementModalTemplate,
        controller: licenseRequirementModalCtrl,
        controllerAs: 'licenseRequirementCtrlModal',
        resolve: {
          reg_id: () => reg_id
        }
      })
      .result.catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  vm.industryCallback = industry => {
    if (!industry || !industry.length) {
      vm.regulatorList = cloneDeep(vm.regulators);
      vm.regulatorGroup = groupBy(vm.regulators, 'license_name');
      vm.licenseList = cloneDeep(vm.regulators);

      vm.license_name = undefined;
      vm.name = undefined;

      return;
    }

    vm.industry = industry;

    const industryLicenses = vm.industryGroup[industry];

    vm.regulatorList = cloneDeep(industryLicenses);
    vm.regulatorGroup = groupBy(industryLicenses, 'license_name');

    vm.licenseList = cloneDeep(industryLicenses);

    vm.license_name = undefined;
    vm.name = undefined;

    vm.formData.reg_id = undefined;
  };

  vm.regulatorCallback = license_name => {
    if (!license_name || !license_name.length) {
      if (vm.industry && vm.industry.length) {
        vm.industryCallback(vm.industry);
      }
      return;
    }

    const regulatorLicenses = vm.regulatorGroup[license_name];

    vm.licenseList = cloneDeep(regulatorLicenses);

    vm.license_name = license_name;
    vm.name = undefined;

    vm.formData.reg_id = undefined;
  };

  vm.licenseCallback = name => {
    if (!name || !name.length) {
      if (vm.license_name && vm.license_name.length) {
        vm.regulatorCallback(vm.license_name);
      }
      return;
    }

    const license = vm.licenseDict[name];

    vm.industry = license.industry;
    vm.license_name = license.license_name;
    vm.name = name;

    vm.formData.reg_id = license.reg_id;
    checkReg();
  };

  vm.resetForm = () => {
    vm.addLicenseToggle = false;
    vm.licenseAdd = false;
    vm.birthday = false;
    vm.summary = false;
    vm.industry = undefined;
    vm.license_name = undefined;
    vm.name = undefined;
    vm.formData.version = undefined;
    vm.formData.reg_id = undefined;
    vm.formData.number = undefined;
    vm.formData.cpeDate = undefined;
    vm.formData.license = 'default';
    vm.formData.issue = moment()
      .startOf('day')
      .subtract(6, 'years')
      .toDate();
    vm.formData.expiration = moment()
      .startOf('day')
      .toDate();
  };

  function checkReg() {
    if (!vm.formData.reg_id) return;

    const { industry, license_name } = vm.regulatorsDict[vm.formData.reg_id];

    vm.industry = industry;
    vm.governingBody = license_name;

    vm.formData.issue = moment()
      .startOf('day')
      .subtract(6, 'years')
      .toDate();
    vm.formData.expiration = moment()
      .startOf('day')
      .toDate();
    vm.formData.number = undefined;
    vm.formData.month = undefined;
    vm.formData.version = undefined;

    vm.selectedRegulator = vm.regulatorsDict[vm.formData.reg_id];

    if (vm.selectedRegulator.cycle_renewal === 'cpeBirth' || vm.selectedRegulator.cycle_renewal === 'cpeBirthNext') {
      return (vm.birthday = true);
    }

    vm.birthday = false;
  }

  function getCPEDate(type, reg_id, expDate, month) {
    const cpeBirth = () => {
      return moment(expDate)
        .date(1)
        .month(Number(month))
        .endOf('month')
        .startOf('day')
        .toDate();
    };

    const cpeBirthNext = () => {
      return moment(expDate)
        .month(Number(month) + 1)
        .date(1)
        .startOf('day')
        .toDate();
    };

    const cpeYearEnd = () => {
      const { day, month } = vm.regulatorsDict[reg_id].year_end;
      return moment(expDate)
        .startOf('day')
        .month(month)
        .date(day)
        .toDate();
    };

    const cpeNextYearEnd = () => {
      const { day, month } = vm.regulatorsDict[reg_id].year_end;
      const year = moment(expDate).year();

      return moment()
        .startOf('day')
        .year(year)
        .month(month)
        .date(day)
        .toDate();
    };

    const fixed = () => {
      const { day, month } = vm.regulatorsDict[reg_id].year_end;
      const intD = moment()
        .startOf('day')
        .month(month)
        .date(day);
      if (intD < moment().startOf('day')) {
        intD.add(1, 'years');
      }
      return intD.toDate();
    };

    const cpePrevYearEnd = () => {
      const { day, month } = vm.regulatorsDict[reg_id].year_end;
      return moment(expDate)
        .startOf('day')
        .month(month)
        .date(day)
        .subtract(1, 'years')
        .toDate();
    };

    const cpeIssue = () => {
      return moment(expDate).toDate();
    };

    const cpe = {
      cpeBirth,
      cpeBirthNext,
      cpeYearEnd,
      cpeNextYearEnd,
      cpeIssue,
      cpePrevYearEnd,
      fixed
    };
    return cpe[type]();
  }

  function filterExistingRegulators(regulators, flatCompliance) {
    const filteredRegulators = regulators.filter(regulator => {
      const base_license = get(regulator, 'join.base_license', false);

      const notExisting = get(regulator, 'join.remove_all', []).reduce((acc, reg_id) => {
        if (flatCompliance[reg_id]) return false;
        return acc;
      }, true);

      return !flatCompliance[regulator.reg_id] && !base_license && notExisting;
    });

    vm.industryList = cloneDeep(filteredRegulators);
    vm.industryGroup = groupBy(filteredRegulators, 'industry');

    vm.regulatorList = cloneDeep(filteredRegulators);
    vm.regulatorGroup = groupBy(filteredRegulators, 'license_name');

    vm.licenseList = cloneDeep(filteredRegulators);
    vm.licenseDict = keyBy(filteredRegulators, 'name');

    vm.regulators = filteredRegulators;
  }

  function activate() {
    vm.compliance = [];
    vm.industry = undefined;
    vm.governingBody = undefined;
    vm.addLicenseToggle = false;

    const qArr = [
      RegulatorClass.loadRegulators(),
      ApiClass.usersIdGet(
        { id: profile_uid, manage: false },
        {},
        {
          queryParams: {
            'include:flatcompliance': true,
            'filter:flatcompliance:latest': true,
            'include:archived': true
          }
        }
      )
    ];

    $q.all(qArr)
      .then(([{ arrCurrent: regulators }, { data: { item: profileInfo, flatcompliance } }]) => {
        vm.regulatorsDict = keyBy(regulators, 'reg_id');

        vm.formData = profileInfo;
        vm.formData.reg_id = undefined;
        vm.formData.license = 'default';
        vm.formData.issue = moment()
          .startOf('day')
          .subtract(6, 'years')
          .toDate();
        vm.formData.expiration = moment()
          .startOf('day')
          .toDate();

        filterExistingRegulators(regulators, flatcompliance);

        vm.licenses = values(flatcompliance);
        vm.resultsQueried = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/licenses/get/index.js